import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import Select from '../../common/Select';
import styles from './IntegrationEbayModal.module.scss';

const marketplaces = {
  EBAY_US: 'United States',
  EBAY_GB: 'United Kingdom (Great Britain)',
  EBAY_AT: 'Austria',
  EBAY_AU: 'Australia',
  EBAY_BE: 'Belgium',
  EBAY_CA: 'Canada',
  EBAY_FR: 'France',
  EBAY_DE: 'Germany',
  EBAY_HK: 'Hong Kong',
  EBAY_IE: 'Ireland',
  EBAY_IN: 'India',
  EBAY_IT: 'Italy',
  EBAY_MY: 'Malaysia',
  EBAY_NL: 'Netherlands',
  EBAY_PH: 'Philippines',
  EBAY_PL: 'Poland',
  EBAY_SG: 'Singapore',
  EBAY_ES: 'Spain',
  EBAY_CH: 'Switzerland',
  EBAY_TH: 'Thailand',
  EBAY_TW: 'Taiwan',
  EBAY_VN: 'Vietnam',
  // EBAY_MOTORS_US: 'United States (Motors)',
};

function IntegrationEbayModal(props) {
  const { onClose } = props;

  const [marketplace, setMarketplace] = useState('');

  const submit = (e) => {
    props.submit(marketplace);
    onClose();

    e.preventDefault();
  };

  const marketplacesOptions = [
    { value: '', label: 'Choose your Marketplace' },
    ...Object.keys(marketplaces).map((key) => ({ value: key, label: marketplaces[key] })),
  ];

  return (
    <ModalWindow open={props.open} onClose={onClose} center>
      <form className={styles.form} onSubmit={submit}>
        <h2>Connect your Ebay Account</h2>

        <hr />

        <div className={styles.body}>
          <label>Select your marketplace:</label>
          <Select options={marketplacesOptions} value={marketplace} onChange={setMarketplace} />
        </div>

        <hr />

        <div className={styles.footer}>
          <div className={styles.button}>
            <Button type="submit" text="OK" disabled={!marketplace} />
          </div>
        </div>
      </form>
    </ModalWindow>
  );
}

export default IntegrationEbayModal;

IntegrationEbayModal.defaultProps = {
  open: false,
};

IntegrationEbayModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};
